import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummarySubtotalPrice.js';
import { RichText } from '@synergycms_core/components/generic';
import connect from 'react-redux/es/connect/connect';
import Price from '@synergycms_core/components/generic/Price';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { getTaxText } from '../../../../utils';
import classnames from 'classnames/bind';


const AvailMainSideSummarySubtotalPrice = class AvailMainSideSummarySubtotalPrice extends React.Component {
  static displayName = 'AvailMainSideSummarySubtotalPrice';

  render() {
    const { config, theme } = this.props,
      {
        totalPrice,
        stepCode,
        text,
        taxes,
        included,
        summaryBreakdownMode
      } = config;

    const { classes } = theme.styles;
    let cx = classnames.bind(classes);

    return (
      <div className={taxes.length > 0 ? classes.content : ''}>
        <div className={classes.contentModule}>
          <div className={classes.contentModuleRow}>
            <div className={classes.contentModuleCell}>
              <RichText text={text} ucFirst={true} translate={true} />
            </div>
            <div className={[classes.contentModuleCell, classes.contentModuleCellPrice].join(' ')}>
              <Price
                amount={totalPrice}
                forceHotelCurrency={stepCode === 'confirmation'}
              />
            </div>
          </div>
        </div>

        <div className={classes.contentModule}>
          {taxes && taxes.length > 0 && ( taxes.length > 1 || !included ) && (
            <>
              {taxes.map((tax, index) => (
                <div className={[classes.contentModuleRow, classes.removeGap, included ? classes.removeGapLarge : ''].join(' ')} key={'tax-' + index}>
                  <div className={[classes.contentModuleCell, classes.large, cx({taxesCell: index === 0}) ].join(' ')}>
                    <RichText
                      text={getTaxText(tax, summaryBreakdownMode)}
                      innerStyle={['roboto11SoftGray300', classes.taxes]}
                      translate={true}
                    />
                    {' '}
                    <RichText
                      text={tax.is_percent ? ' (' + tax.value + '%)' : ''}
                      innerStyle={['roboto11SoftGray300', classes.taxes]}
                      translate={true}
                    />
                  </div>
                  <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short, cx({taxesCell: index === 0})].join(' ')}>
                    <Price
                      innerStyle={['roboto11SoftGray300', classes.priceNumbers, classes.taxes]}
                      amount={tax.tax_amount}
                      forceHotelCurrency={stepCode === 'confirmation'}
                    />
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    )
  }
};

const mapStateToProps = (store, ownProps) => {
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code'])
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'totalPrice',
    'stepCode',
    'text',
    'taxes',
    'included',
    'summaryBreakdownMode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummarySubtotalPrice);
